import { forwardRef } from "react";
import { Input } from "@/components/ui/input";

// Restricts input to exactly 10 numeric digits.
// Accepts value/onChange props like a normal <input>.
const MobileInput = forwardRef(function MobileInput(
  { value, onChange, required, className = "", ...rest },
  ref
) {
  const handleChange = (e) => {
    const digits = (e.target.value || "").replace(/\D/g, "").slice(0, 10);
    if (typeof onChange === "function") {
      // Emit a synthetic-ish event: onChange(digits) OR onChange(event)
      // Support both patterns used across pages.
      if (onChange.length >= 1 && typeof onChange === "function") {
        // Prefer passing back a value-only string for simple pages,
        // callers using `(e) => set(e.target.value)` still work because we
        // mutate the event target below.
        try {
          e.target.value = digits;
        } catch {}
        onChange(e);
      }
    }
  };

  return (
    <Input
      ref={ref}
      type="tel"
      inputMode="numeric"
      autoComplete="tel"
      pattern="\d{10}"
      minLength={10}
      maxLength={10}
      title="Mobile number must be exactly 10 digits"
      value={value ?? ""}
      onChange={handleChange}
      onKeyDown={(e) => {
        // block letters entirely for a snappy UX
        if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
      }}
      required={required}
      className={className}
      placeholder="10-digit mobile"
      {...rest}
    />
  );
});

export default MobileInput;

// Utility for programmatic validation
export function isValidMobile(v) {
  return /^\d{10}$/.test(String(v || ""));
}
